<template>
  <v-row class="d-flex flex-wrap">
    <!-- filter -->
    <v-col cols="12">
      <TagAnalysisFilter @changechartInfoState="changeChartInfoState" :chartInfoState="chartInfoState"
                         :chartInfo="chartInfo"/>
    </v-col>

    <v-col :class="{ 'd-none': getDateRange.length < 1 }">
      <v-row id="overviewContent">
        <v-col cols="12" id="crowdTag">
          <CrowdTag id="crowdTag" @addChartInfo="addChart" :chartInfoState="chartInfoState"/>
        </v-col>

        <!-- 興趣 -->
        <InterestTab id="interestTab" @goto="scrollToTarget" @addChartInfo="addChart" :chartInfoState="chartInfoState"/>

        <!-- 母體標籤 -->
        <PopulationTag id="populationTag" @goto="scrollToTarget" @addChartInfo="addChart" :chartInfoState="chartInfoState"/>
      </v-row>
    </v-col>
    <div id="crowdTagPercent" style="display:none"></div>
    <div id="interestTypeSort" style="display:none"></div>
    <div id="interestTabSort" style="display:none"></div>
    <div id="populationTagDay" style="display:none"></div>
    <div id="populationTagWeek" style="display:none"></div>
  </v-row>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      chartInfo: [],
      chartInfoState: false,
    }
  },
  components: {
    TagAnalysisFilter: () => import("@/components/taganalysis/TagAnalysisFilter.vue"),
    InterestTab: () => import("@/components/taganalysis/InterestTab.vue"),
    PopulationTag: () => import("@/components/taganalysis/PopulationTag.vue"),
    CrowdTag: () => import("@/components/taganalysis/CrowdTag.vue"),
  },
  computed: {

    ...mapGetters("taganalysis", ["getDateRange", "getDate"]),
    showChart() {
      return !this.getDate ? "d-none" : "";
    },
  },
  methods: {
    scrollToTarget(value) {
      this.$vuetify.goTo(value);
    },
    changeChartInfoState(value) {
      this.chartInfoState = value;
      if (value === false) {
        this.chartInfo = [];
      }
    },
    addChart(value) {
      this.chartInfo.push(Object.assign(value));
    },
  },
};
</script>
